import { useCallback } from "react"

import { DocumentForm } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useHorizontalSignUpdateDocument } from "../../hooks/mutations/useHorizontalSignUpdate"

export const HorizontalSignAddDocumentFormPost = (props) => {
    const {
        signId,
        onClose,
        onSubmitting,
        onChange,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const mutation = useHorizontalSignUpdateDocument(signId, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.horizontalSignDocumentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.horizontalSignDocumentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: (error) => {
            onSubmitting(false)
            console.error("Error updating horizontal sign document:", error)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            document: formValues,
            horizontal_sign: signId,
        }
        mutation.mutate(values)
        onSubmitting(true)
    }, [mutation, signId, onSubmitting])

    return <DocumentForm
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}